import "moment-timezone";

import moment from "moment";

export const { format: formatPrice } = new Intl.NumberFormat('pt-br', {
  style: 'currency',
  currency: 'BRL',
});

export const truncate = (fullStr, strLen, separator) => {
  if (fullStr.length <= strLen) return fullStr;

  separator = separator || '...';

  let sepLen = separator.length,
    charsToShow = strLen - sepLen,
    frontChars = Math.ceil(charsToShow / 2),
    backChars = Math.floor(charsToShow / 2);

  return (
    fullStr.substr(0, frontChars) +
    separator +
    fullStr.substr(fullStr.length - backChars)
  );
};

export const formatToCEP = (cep) => {
  cep = cep.replace(/\D/g, '');

  if (cep.length !== 8) {
    return 'CEP inválido';
  }

  const cepFormatado = cep.slice(0, 5) + '-' + cep.slice(5);

  return cepFormatado;
};

export const formatDateToBRString = (date) => {
  return new Intl.DateTimeFormat('pt-BR').format(date);
};

export const formatReal = (valor) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(valor);

export const formatToString = (number, action) => {
  if (action === 'currency') {
    return number.toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
    });
  } else if (action === 'points') {
    return number.toLocaleString('pt-br', { minimumFractionDigits: 2 });
  } else if (action === 'pointsWithoutDecimal') {
    return number.toLocaleString('pt-br', { maximumFractionDigits: 0 });
  } else {
    return number.toLocaleString('pt-br', { minimumFractionDigits: 0 });
  }
};

export const convertPoints = (value, fixed) => {
  const number = parseFloat(value);

  return number
  .toFixed(fixed) // Fixar o número de casas decimais
  .replace(".", ",") // Substituir o ponto decimal por vírgula
  .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Adicionar pontos como separadores de milhares

};

export const clearZipcode = (value) => {
  return value.replace(/[^\d]/g, '');
};

export const formatToNumber = (number) => {
  if (number === '') return 0;
  let formatedNumber = number.toString().replace('R$ ', '');
  formatedNumber = number.replace('R$', '');
  formatedNumber = formatedNumber.replaceAll('.', '');
  formatedNumber = formatedNumber.replace(',', '.');
  formatedNumber = parseFloat(formatedNumber);
  return formatedNumber;
};

export const formatToCNPJ = (number) => {
  if (isNaN(parseInt(number)) || number.length < 14) return '';

  return number.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    '$1.$2.$3/$4-$5'
  );
};

export const formatToCPF = (number) => {
  if (isNaN(parseInt(number)) || number.length < 11) return '';

  return number.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

export const formatDocument = (number) => {
  if (number.length == 14) return formatToCNPJ(number);
  if (number.length == 11) return formatToCPF(number);

  return "-";
};

export const formatCEP = (cep) => {
  cep = cep.replace(/\D/g, '');

  return cep.replace(/(\d{5})(\d{3})/, "$1-$2");
}

export const getOnlyNumbers = (value) => {
  if (value) {
    value = value.replace(/\s/g, '');
    return value.replace(/[-_./]/g, '');
  }
  return value;
};

export const removeSpecialCharacters = (value) => {
  if (value) {
    return value.replace(/[@!^%$\/\\#,+()$~%.'":*?<>{}_&]/g, '');
  }
  return value;
};

export const formatToRedemption = (number) => {
  if (number === '' || number === undefined || number === null) return '';

  return number.match(/\d/g).join('');
};

export const formatToZipCode = (number) => {
  if (isNaN(parseInt(number)) || number.length < 8) return '';

  return number.replace(/^(\d{5})(\d{3})/, '$1-$2');
};

export const formatToMobilePhone = (number) => {
  if (isNaN(parseInt(number)) || number.length < 11) return '';
  const regex = /^(\d{2})(\d{5})(\d{4})$/;
  return number.replace(regex, '($1) $2-$3');
};

export const limitTextSize = (string, size) => {
  return string.trim().length > size
    ? string.trim().substr(0, size) + '...'
    : string.trim();
};

export const validateEmail = (email = '') => {
  const validRegex =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return !!email.match(validRegex);
};

export const formatToCents = (value) => {
  value = (value + '').replace(/[^\d.-]/g, '');
  if (value && value.includes('.')) {
    value = value.substring(0, value.indexOf('.') + 3);
  }

  return value ? Math.round(parseFloat(value) * 100) : 0;
};

export const formatErrorMessage = (message) => {
  const formatedMessage = message.replace(
    /(\s\(.*?\))|<\w+(\s+("[^"]*"|'[^']*'|[^>])+)?>|<\/\w+>/gi,
    ''
  );

  return formatedMessage
}

export const getLocalizedDate = (utcDate) => {
  const defaultTimezone = "America/Sao_Paulo";
  const dateFormat = "MM/DD/YYYY HH:mm:ss";

  moment.locale("pt-br");

  return moment.utc(utcDate, dateFormat).tz(defaultTimezone).format("lll");
}

export const formatCellPhone = (phone) => {
  const getPureValue = phone.replace(/\D/g, '').replace(/[\(\)\-)]/g, '')

  if (getPureValue.length === 2) {
    return `(${getPureValue})`
  } else if (getPureValue.length > 2 && getPureValue.length <= 7) {
    return `(${getPureValue.substring(0, 2)}) ${getPureValue.substring(2, 7)}`
  } else if (getPureValue.length > 7) {
    return `(${getPureValue.substring(0, 2)}) ${getPureValue.substring(2, 7)}-${getPureValue.substring(7, 11)}`
  } else {
    if (/[a-zA-Z]/g.test(getPureValue)) return ''
    return getPureValue.substring(0, 15)
  }
}
